import { H1Headline, H2Headline, H3Headline, NormalText, Title } from 'almanac-ui/icons/16'
import { Icon } from 'almanac-ui/icons/Types'
import { schema, SUPPORTED_FONTS } from 'prose-core'
import { NodeType } from 'prosemirror-model'
import { PluginKey } from 'prosemirror-state'

export const TABLE_PROMPT_MAX_SIZE = 20

export const DEFAULT_MONOSPACE_FONT = 'Roboto Mono'
export const MONOSPACE_FONTS: Array<(typeof SUPPORTED_FONTS)[number]> = [
  'IBM Plex Mono',
  'JetBrains Mono',
  'Roboto Mono',
  'Space Mono',
  'Ubuntu Mono',
]

export const TEXT_STYLES: { [key: string]: { attrs?: any; textValue: string; type: NodeType; icon: Icon } } = {
  normal: {
    textValue: 'Normal',
    type: schema.nodes.paragraph,
    icon: NormalText,
  },
  title: {
    attrs: { level: 1 },
    textValue: 'Title',
    type: schema.nodes.heading,
    icon: Title,
  },
  heading1: {
    attrs: { level: 2 },
    textValue: 'Heading 1',
    type: schema.nodes.heading,
    icon: H1Headline,
  },
  heading2: {
    attrs: { level: 3 },
    textValue: 'Heading 2',
    type: schema.nodes.heading,
    icon: H2Headline,
  },
  heading3: {
    attrs: { level: 4 },
    textValue: 'Heading 3',
    type: schema.nodes.heading,
    icon: H3Headline,
  },
}

// We don't have a plugin of our own to handle keypress, we use `prosemirror-keymap`
// This is for staging the keypress handlers' metadata for tracked changes
export const KeyhandlerMetadataKey = new PluginKey(`KeyhandlerMetadata`)
